import React, { useEffect, useRef, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Avatar, Button, Paper, styled, Typography, Badge, IconButton } from '@mui/material';
import ColorModeSelect from '../../theme/ColorModeSelect';
import { fetchUserProfile, logout } from "../../redux/Slice/AuthSlice";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from "../../redux/Slice/loaderSlice";
import { Link, useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { motion, AnimatePresence } from "framer-motion";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CloseIcon from '@mui/icons-material/Close';
import { formatDistanceToNow } from "date-fns";

const CustomAppBar = styled(AppBar)(({ theme }) => ({
  width: '100%',
  height: '50px',
  margin: 'auto',
  background: '#2FB354',
}));

const DrawerAppBar = () => {
  const [subshow, setSubshow] = useState(false);
  const [notificationsVisible, setNotificationsVisible] = useState(false);
  const menuRef = useRef(null);
  const notificationsRef = useRef(null);
  const { profile } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [notify, setNotify] = useState([]);
  const [ws, setWs] = useState(null);
   console.log("ws:",ws);
  
  const {user} = useSelector((state)=> state.auth);
  // console.log("User:",user);

  // console.log(profile)

  useEffect(() => {
    if (profile?._id && user.token) {
      try {
        const socket = new WebSocket(`${process.env.REACT_APP_WS_URL}?token=${user.token}`);
        
        socket.onopen = () => {
          socket.send(JSON.stringify({ type: 'register', userId: profile._id }));
        };

        socket.onmessage = (event) => {
          const data = JSON.parse(event.data);
          console.log("Data:", data);
          if (data.type === 'all-notifications-status-updated') {
            dispatch(fetchUserProfile());
          } else {
            setNotify((prev) => [...prev, data]);
          }
        };

        socket.onerror = (error) => {
          console.error("WebSocket error:", error);
        };

        setWs(socket);

        return () => {
          socket.close();
        };
      } catch (error) {
        console.error("Error initializing WebSocket:", error);
      }
    }
  }, [profile?._id, user.token, dispatch]);


  console.log("Notify:", notify);

  const handleLogOut = () => {
    dispatch(setLoading(true));
    dispatch(logout())
      .unwrap()
      .catch((error) => console.error("Logout failed:", error))
      .finally(() => dispatch(setLoading(false)));
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setSubshow(false);
    }  
    if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
      setNotificationsVisible(false); 
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleProfile = () => setSubshow(!subshow);



  const handleNotificationToggle = () => {
    setNotificationsVisible(!notificationsVisible);
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({
        type: 'all-status',
        userId: profile._id,
      }));
    }
  };

  useEffect(() => {
    dispatch(setLoading(true))
    dispatch(fetchUserProfile())
      .then(()=>{
        dispatch(setLoading(false));
      })
  }, [dispatch]);

  useEffect(()=>{
    const notifications = profile?.notifications || [];
    setNotify(notifications);
  }, [profile])


  const unseenNotifications = notify.filter(n => n.status === 'unseen') || [];
  

  const handleNotificationClick = (notif) => {
    if(notif?.screen === "lead"){
      console.log("Notify:", notif);
      navigate(`/lead/${notif?.screenId}`)
      setNotificationsVisible(false);
    }
  };

  const markAllAsRead = () => {
    setNotify((prev) => prev.map((n) => ({ ...n, status: "seen" })));
  };

  const handleCloseNotifications = () => {
    setNotificationsVisible(false);
  };
// Generate a hash from the string
const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    color += ('00' + ((hash >> (i * 8)) & 0xff).toString(16)).slice(-2);
  }
  return color;
};

// Calculate Brightness of the color
const getContrastColor = (hexColor) => {
  // If the background color is pure white, return black text
  if (hexColor === '#FFFFFF') return 'black';

  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);

  // Calculate luminance
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // If luminance is less than 128, return white text, else black text
  return luminance < 128 ? 'white' : 'black';
};



  return (
    <Box sx={{ display: 'flex', bgcolor: "#2FB354" }}>
      <CustomAppBar component="nav">
        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
          <Toolbar sx={{ display: 'flex', gap: 2 }}>
            <ColorModeSelect />
            <Button ref={menuRef} size="large" onClick={handleProfile}>
              <Avatar src={profile?.imgUrl || ''}>{profile?.name?.charAt(0)}</Avatar>
              <Box mx={2} display='flex' flexDirection='column'>
                <Typography>{profile?.name}</Typography>
                <Typography fontSize={12}>{profile?.role}</Typography>
              </Box>
              <KeyboardArrowDownIcon />
              {subshow && (
                <Paper sx={{ position: 'absolute', top: '50px', right: 0, px: 2.5, borderRadius: 0.5 }}>
                  <Link to='/setting' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Box sx={{ py: 2, px: 2 }}>
                      <AccountCircleIcon sx={{ mr: 2 }} />
                      <Typography>Profile</Typography>
                    </Box>
                  </Link>
                  <Link style={{ textDecoration: 'none', color: 'inherit' }} onClick={handleLogOut}>
                    <Box sx={{ py: 2, px: 2 }}>
                      <LockIcon sx={{ mr: 2 }} />
                      <Typography>Logout</Typography>
                    </Box>
                  </Link>
                </Paper>
              )}
            </Button>
            <Badge  ref={notificationsRef}
              color="error"
              badgeContent={notificationsVisible ? null : unseenNotifications.length || null}
              onClick={handleNotificationToggle}
            >
              <NotificationsIcon sx={{ color: '#fff' }} />
            </Badge>
          </Toolbar>
        </Box>
      </CustomAppBar>

      <AnimatePresence>
        {notificationsVisible && (
          <motion.div
            initial={{ y: -10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -10, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Paper
              sx={{
                position: "absolute", top: "60px", right: "10px", width: "350px", padding: "1rem", maxHeight: "400px", overflowY: "auto", zIndex: 1000, borderRadius: "10px", boxShadow: 3,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="h6">Notifications</Typography>
                <IconButton size="small" onClick={handleCloseNotifications} sx={{ color: 'inherit' }}>
                  <CloseIcon />
                </IconButton>
              </Box>

              {notify.length === 0 ? (
                <Typography>No notifications</Typography>
              ) : (
                [...notify].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map((notif, index) => (
                  <motion.div
                    key={index}
                    whileHover={{ scale: 1.02 }}
                    transition={{ duration: 0.2 }}
                    onClick={() => handleNotificationClick(notif)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                      cursor: "pointer",
                    }}
                  >
                   <Avatar src={notif?.senderAvatar || ''} alt="sender" sx={{ mr: 2 , position: 'relative',fontWeight: 'bold',  color: notif?.companyName ? getContrastColor(stringToColor(notif?.companyName)) : 'gray', bgcolor: notif?.companyName ? stringToColor(notif?.companyName) : "white"}}> 
                   {notif.status === "unseen" && <Badge color="error" variant="dot" sx={{position: 'relative',top: 0, right: 0, border: '2px solid white', }} />}
                    {notif?.senderAvatar ? null : notif?.companyName?.split(' ')[0]?.charAt(0).toUpperCase()}
                    </Avatar>

  

                    <Box flex={1}>
                      <Typography variant="body2">{notif?.message}</Typography>
                      <Typography variant="caption" sx={{ color: "gray" }}>
                        {notif?.createdAt ? `${formatDistanceToNow(new Date(notif.createdAt))} ago` : ""}
                      </Typography>
                    </Box>
                   
                    <DoneAllIcon sx={{ fontSize: '18px', color: notify.every(n => n.status === 'seen') ? 'blue' : 'inherit' }} onClick={markAllAsRead} />
                {/* </IconButton> */}
                  </motion.div>
                ))
              )}
            </Paper>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default DrawerAppBar;